export enum EarningsDocumentType {
  TDS = 'TDS',
  PAYMENT_ACKNOWLEDGEMENT_RECEIPT = ' Payment Acknowledgement Reciept',
}
